import React from 'react';
import { Route, Navigate } from 'react-router-dom';
import Layout from './layoutComponents/Layout';
import Login from './pages/Login';
import Workspace from './pages/Workspace';
import Passwords from './pages/Passwords';
import ProtectedRoute from './components/ProtectedRoute';

export const routes = [
  {
    path: '/login',
    element: <Login />,
  },
  {
    path: '/',
    element: <Navigate to="/login" replace />,
  },
  {
    path: '/workspace',
    element: (
      <ProtectedRoute>
        <Layout title="Workspace" subtitle="Select a folder and table">
          <Workspace />
        </Layout>
      </ProtectedRoute>
    ),
  },
  {
    path: '/dashboard',
    element: <Navigate to="/workspace" replace />,
  },
  {
    path: '/passwords',
    element: (
      <ProtectedRoute>
        <Layout title="Passwords" subtitle="Manage and view all your saved passwords">
          <Passwords />
        </Layout>
      </ProtectedRoute>
    ),
  },
];

export const renderRoutes = () => {
  return routes.map((route, index) => (
    <Route key={index} path={route.path} element={route.element} />
  ));
};

